import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../common/component/LoaderProvider";
import { useFieldArray, useForm } from "react-hook-form";
import useValidation from "../../common/utils/validationRules";
import { useToast } from "../../common/component/Toast";
import CommonButton from "../../common/component/commonButton";
import StepperModal from "../../common/component/commonStepper";
import { useTranslation } from "react-i18next";
import Actionicon from "../../assests/images/action.png";
import Search from "../../assests/images/add button.png";
import { OverlayPanel } from "primereact/overlaypanel";
import CommonLoader from "../../common/component/commonLoader";
import {
  getByPharmacyIdCalendar,
  updatePharmacyCalendar,
} from "../../service/action/actioncreator/CalendarAction/CalendarAction";
import { formatDate } from "../../common/utils/commonFunction";
import dayjs from "dayjs";
import { AddCalendar } from "../../service/action/actioncreator/CalendarAction/CalendarAction";

const FarmacieInsertionRetail = ({
  size,
  pharmacyData,
  retailListData,
  pharmacyDropdown,
  viewRoleId,
  pharmacyViewData,
  rowDataView
}) => {
  const loading = useSelector(
    (state) => state.structureReducer.strutureUpdateLoading
  );
  const getData = useSelector(
    (state) => state.structureReducer.structureGetIdResponse
  );

  const calendarGetById = useSelector(
    (state) => state.calendarReducer.hospitalPharamacyCalendarResponse
  );

  const [calendarViewData, setCalendarViewData] = useState([]);
  const weekDays = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

  const overlayPanelRef = useRef(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pharmacyDropdowns, setPharmacyDropdowns] = useState(pharmacyDropdown);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [progress, setProgress] = useState(33);
  const [currentStep, setCurrentStep] = useState(1);
  const [modalEdit, setModalEdit] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslation("translation");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowData, setRowData] = useState();
  const [filterPharmacy, setFilteredPharmacy] = useState([]);
  const [filteredDropdwon, setFilteredDropdwon] = useState([]);
  const [rowdatavalue, setrowDataValue] = useState({
    CalendarListRowData: "",
    CalendarListRowDataID: "",
    CalendarListRowDataEdit: false,
    CalendarListRowDataDelete: "",
  });
  const [calendarValue, setCalendarValue] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
    reset,
    watch,
    trigger,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      DropdownFieldsPharmacy: [{ value: null }],
      calenderList: [
        {
          startDate: null,
          endDate: null,
          times: Array(7).fill({ startTime: null, endTime: null }),
        },
      ],
    },
  });
  function formatDateToYYYYMMDD(dateString) {
    const apiResponseDate = new Date(dateString);

    // Extract the year, month, and day
    const year = apiResponseDate.getFullYear();
    const month = (apiResponseDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed (0-11)
    const day = apiResponseDate.getDate().toString().padStart(2, "0"); // Day of the month

    // Format as "YYYY-MM-DD"
    return `${year}-${month}-${day}`;
  }
  const {
    fields: pharmacyTabFields,
    append: appendPharmacyTab,
    remove: removePharmacyTab,
  } = useFieldArray({
    control,
    name: "DropdownFieldsPharmacy",
  });
  const {
    fields: calenderFields,
    append: appendCalender,
    remove: removeCalender,
  } = useFieldArray({
    control,
    name: "calenderList",
  });
  watch("DropdownFieldsPharmacy");
  watch("calenderList");
  const { validateField } = useValidation();
  const {
    showLoader,
    hideLoader,
    loadingStepper,
    showStepperLoader,
    hideStepperLoader,
  } = useLoader();
  const { showToast } = useToast();
  const dispatch = useDispatch();

  const stepConfigs = {
    1: [
      {
        titleMain: t("text_timetables_calendars"),
        textFooter: "Inserisci almeno una Farmacia Ospedaliera di riferimento",
        fields: [
          {
            type: "calender-field",
            content: t("text_calendar"),
            img: { Search },
            modalEdit: false,
            previousBtn: false,
          },
        ],
      },
    ],
    2: [
      {
        titleMain: t("text_timetables_calendars"),
        textFooter: "Inserisci almeno una Farmacia Ospedaliera di riferimento",
        fields: [
          {
            type: "calender-field",
            content: t("text_calendar"),
            img: { Search },
            modalEdit: true,
            previousBtn: false,
          },
        ],
      },
    ],
  };

  const roleBasedSteps = modalEdit ? stepConfigs[2] : stepConfigs[1];
  const constructTime = (time) => {
    if (!time || typeof time !== "string") return null;
    const timeString = time ?? null; // Example: hh:mm:ss format
    const currentDate = new Date(); // Get current date

    // Create a new date object with the current date and specified time
    const dateObject = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      ...timeString?.split(":")?.map(Number) // Convert hh:mm:ss to numbers
    );

    return dateObject;
  };

  const constructTimings = (weekDayData) => {
    let newData = { ...weekDayData };
    let day = "";
    switch (newData?.weekday) {
      case "monday":
        day = "Lun";
        break;
      case "tuesday":
        day = "Mar";
        break;
      case "wednesday":
        day = "Mer";
        break;
      case "thursday":
        day = "Gio";
        break;
      case "friday":
        day = "Ven";
        break;
      case "saturday":
        day = "Sab";
        break;
      case "sunday":
        day = "Dom";
        break;
      default:
        break;
    }
    newData.weekday = day;

    newData.startTime = constructTime(weekDayData?.openTime);
    newData.endTime = constructTime(weekDayData?.closeTime);

    return newData;
  };

  const handleModalClose = () => {
    setIsSuccess(false);
    setIsModalOpen(false);
    setModalEdit(false);
    reset();
    hideStepperLoader();
  };
  const handleCloseSubmission = () => {
    setIsModalOpen(false);
  };
  const handleModalSubmit = () => {};

  const handleSubmitStep = () => {
    const filedCalendar = calendarData?.filter(
      (item) =>
        item !== null &&
        Object.values(item).every(
          (value) => value !== null && value !== undefined && value !== ""
        )
    );
    if (modalEdit) {
      // setModalEdit(true)
      // UserId,AuthenticationType,AuthenticationFor,OtpCode
      let userId = localStorage.getItem("userId");
      var headers = {
        UserId: userId,
        AccessIdentifier: "Validate",
      };
      let ID = rowdatavalue?.CalendarListRowData?.id;
      var payload = {
        pharmacyId: retailListData?.id,
        startDate: filedCalendar
          ?.map((obj) => formatDate(obj.startDate))
          ?.toString(),
        endDate: filedCalendar
          ?.map((obj) => formatDate(obj.endDate))
          ?.toString(),
        weekDaySessions: filedCalendar?.[0]?.times?.map((time, index) => ({
          // weekDay: time.weekDay=="Lun" ? "monday" : time.weekDay=="Mar" ? "tuesday" : time.weekDay=="Mer" ? "wednesday" :time.weekDay=="Gio" ? "thursday" : time.weekDay=="Ven" ? "friday" : time.weekDay=="Sab" ? "saturday" : "sunday",
          weekDay: time.weekDay,
          sessionType: "session1",
          openTime: time.startTime
            ? dayjs(time.startTime).format("HH:mm:ss")
            : null,
          closeTime: time.endTime
            ? dayjs(time.endTime).format("HH:mm:ss")
            : null,
          isSpecialDay: false,
          date: null,
          isClosed: false,
        })),
      };

      // how to construct teh week days in payload getting
      // const weekDays = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
      let id = retailListData?.id;
      var updateCalendar = {
        ID,
        id,
        payload,
        headers,
        showToast,
        showLoader,
        hideLoader,
        t,
      };

      dispatch(updatePharmacyCalendar(updateCalendar, setIsModalOpen));
      setCalendarData([]);
      handleModalClose();
      setModalEdit(false);
    } else {
      const payloadtest = filedCalendar.map((ele, index) => {
        return {
          pharmacyId: pharmacyViewData?.id,
          startDate: formatDateToYYYYMMDD(ele.startDate),
          endDate: formatDateToYYYYMMDD(ele.endDate),
          weekDaySessions: ele.times.map((time) => {
            const dayOfWeek = !!time.endTime
              ? time.endTime?.toLocaleString("en-US", { weekday: "long" })
              : "";

            const today = new Date();
            // formatDateToYYYYMMDD(today)
            return {
              weekDay:
                time?.weekDay == "Lun"
                  ? "monday"
                  : time?.weekDay == "Mar"
                  ? "tuesday"
                  : time?.weekDay == "Mer"
                  ? "wednesday"
                  : time?.weekDay == "Gio"
                  ? "thursday"
                  : time?.weekDay == "Ven"
                  ? "friday"
                  : time?.weekDay == "Sab"
                  ? "saturday"
                  : "sunday",
              sessionType: "session1",
              openTime: time?.startTime
                ? dayjs(time?.startTime).format("HH:mm:ss")
                : null,
              closeTime: time?.endTime
                ? dayjs(time?.endTime).format("HH:mm:ss")
                : null,

              isClosed: false,
              isSpecialDay: false,
              date: null,
            };
          }),
        };
      });

      let pharmacyList = {
        pharmacyListID: pharmacyViewData?.id,
        Ispharmacy: false,
        showToast,
        showLoader,
        hideLoader,
        t,
      };
      // dispatch(AddCalendar(payloadtest,setIsSuccess,setIsModalOpen))
      dispatch(
        AddCalendar(payloadtest, setIsSuccess, setIsModalOpen, pharmacyList)
      );
      setCalendarData([]);
      handleModalClose();
    }
  };
  const formattedValue = pharmacyDropdown?.map((option) => ({
    label: `${option?.name}`,
    value: option?.id,
  }));
  const [listId, setListId] = useState();
  const handleThreeDotsClick = (event, data, rowid) => {
    setListId(rowid);
    setRowData(rowData);
    setrowDataValue({
      ...rowdatavalue,
      CalendarListRowData: data,
      CalendarListRowDataID: rowid,
    });
    const startDate = data?.startDate ? new Date(data?.startDate) : null;
    const endDate = data?.endDate ? new Date(data?.endDate) : null;
    const timingData = data?.weekDaySessions?.map((weekDayData) =>
      constructTimings(weekDayData)
    );

    setValue(`calenderList.0.startDate`, startDate);
    setValue(`calenderList.0.endDate`, endDate);
    setValue(`calenderList.0.times`, timingData);

    overlayPanelRef.current?.toggle(event);
  };
  useEffect(() => {
    const checkcase =
      pharmacyDropdown?.length > 0 &&
      pharmacyDropdown?.filter((obj1) =>
        getData?.pharmacyIds?.some((obj) => obj == obj1.id)
      );
    setFilteredPharmacy(checkcase);
  }, [getData, pharmacyDropdown]);

  const PharmacyListEdit = (id) => {
    setValue(
      "pharmacy",
      formattedValue?.find((obj) => obj.value === id)?.value
    );
    setModalEdit(true);
    if (pharmacyDropdown?.length > 0 && filterPharmacy?.length > 0) {
      const filteredDropdwon =
        pharmacyDropdown?.length > 0 &&
        pharmacyDropdown?.filter((obj) =>
          filterPharmacy?.some((obj1) => obj1.id == obj.id)
        );
      setFilteredDropdwon(filteredDropdwon);
    }
  };

  useEffect(() => {
    dispatch(getByPharmacyIdCalendar(retailListData?.id));
  }, [retailListData?.id]);
  useEffect(() => {
    setCalendarViewData(calendarGetById);
  }, [calendarGetById]);

  useEffect(() => {
    const filtered =
      pharmacyDropdown?.length > 0 &&
      pharmacyDropdown?.filter((obj) => {
        return pharmacyData?.pharmacyIds.includes(obj?.id);
      });
    setFilteredPharmacy(filtered);
  }, []);

  useEffect(() => {
    if (pharmacyDropdown?.length > 0 && filterPharmacy?.length > 0) {
      const filteredDropdwon =
        pharmacyDropdown?.length > 0 &&
        pharmacyDropdown?.filter((obj) =>
          filterPharmacy?.some((obj1) => obj1.id == obj.id)
        );

      setFilteredDropdwon(filteredDropdwon);
    }
    setPharmacyDropdowns(pharmacyDropdown);
  }, [pharmacyDropdown, filterPharmacy]);
  const handleRegister = () => {
    setIsModalOpen(true);
    // setCurrentStep(1);
    // setProgress(33);
  };

  return (
    <>
      <div>
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            className=""
            style={{
              flex: 1,
            }}
          >
            {/* <p>Farmacie ospera</p> */}
            <p style={{ fontWeight: "bold" }}>
              {t("menu_hospital_pharmacies").toUpperCase()}
            </p>
            <div
              style={{ display: "flex", flexDirection: "column", width: "95%" }}
            >
              {/* {pharmacyData?.length > 0 &&
                filterPharmacy?.map((pharmacy) => ( */}
              {calendarViewData?.length > 0 &&
                calendarViewData?.map((obj, index) => (
                  <div
                    key={index}
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px",
                      border: "0 solid #ddd",
                      marginBottom: "10px",
                      backgroundColor: "#f6fafc",
                    }}
                  >
                    {/* <div key={index}> */}
                    <div style={{ width: "auto" }}>
                      {`Valido dal ${obj.startDate} al ${obj.endDate}`}
                    </div>

                    {rowDataView?.isActive &&<img
                      src={Actionicon}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "100%",
                      }}
                      onClick={(e) => handleThreeDotsClick(e, obj, obj.id)}
                    />}
                  </div>
                  // </div>
                ))}
              {/* ))
                 } */}

              <div
                className="flex justify-between items-center mt-8"
                style={{
                  width: "90%",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {/* const renderCustomPagination = () => ( */}
              </div>
            </div>
          </div>
        </div>
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            gap: 10,
          }}
        >
          <CommonButton
            label={`${t("text_pharmacy_operator")}`}
            inputStyle={true}
            className="btn btn-success mt-3 p-2  w-20 input-style-common text-white"
            type="button"
            variant="success"
            onClick={handleRegister}
            disabled={rowDataView?.isActive == true ? false : true}

          />
          <CommonButton
            disabled={true}
            label={"Esporta lista"}
            inputStyle={true}
            className={`btn btn-cancel  mb-3 input-style-common btn-cancel-style btn-padding primary-text-color `}
            type="button"
            variant={"cancel"}
          />
          {/* <div style={{display:'flex',flexDirection:'row'}}>
            <div className="pagination-container me-3">
                  <span className="pagination-info">
                   
                    1 di 1
                  </span>
                  <img
                    src={arrowLeft}
                    alt="Previous"
                    className="pagination-icon pointer"
                  
                  />

                  <span className="pagination-page ms-2 me-2">
                    Pag {currentPage}
                  </span>
                  <img
                    src={arrowRight}
                    alt="Next"
                    className="pagination-icon pointer"
                    onClick={() => {}}
                  />
                </div>
               
            </div> */}
        </div>
        {(isModalOpen || modalEdit) && (
          <StepperModal
            isModalOpen={isModalOpen ? isModalOpen : modalEdit}
            handleModalClose={handleModalClose}
            currentStep={currentStep}
            progress={progress}
            getValues={getValues}
            isSuccess={false}
            control={control}
            errors={errors}
            register={register}
            setValue={setValue}
            validateField={validateField}
            handleCloseSubmission={handleCloseSubmission}
            watch={watch}
            roleBasedSteps={roleBasedSteps}
            onSubmit={handleSubmit(handleModalSubmit)}
            handleSubmitStep={handleSubmitStep}
            trigger={trigger}
            dropdownOptions={
              pharmacyDropdown?.length > 0 ? pharmacyDropdown : []
            }
            setProgress={setProgress}
            setCurrentStep={setCurrentStep}
            fieldsPharmacy={pharmacyTabFields}
            appendPharmacy={appendPharmacyTab}
            removePharmacy={removePharmacyTab}
            mainTitle={"Aggiunta Farmacie Ospedaliere di riferimento"}
            isUserFlag={true}
            size="xl"
            filteredDropdownTab={
              filteredDropdwon?.length > 0 ? filteredDropdwon : []
            }
            progressHide={true}
            fieldsCalender={calenderFields}
            appendCalender={appendCalender}
            removeCalender={removeCalender}
            calendarValue={calendarValue}
            setCalendarValue={setCalendarValue}
            calendarData={calendarData}
            setCalendarData={setCalendarData}
          />
        )}
        <OverlayPanel ref={overlayPanelRef} className="custom-overlay-panel">
          <div className="popover-menu">
            {/* <div
              onClick={() => PharmacyDeleteList(listId)}
              className="popover-option"
            >
              {" "}
              Elimina{" "}
            </div> */}
            <div
              onClick={() => PharmacyListEdit(listId)}
              className="popover-option"
            >
              {" "}
              Modifica{" "}
            </div>
          </div>
        </OverlayPanel>
        {/* <ConfirmAlert
          visible={showConfirm}
          onHide={onHide}
          message="Sei sicuro di voler eliminare il record del paziente?"
          onConfirm={onConfirm}
        /> */}
        {!loadingStepper && <CommonLoader loading={loading} />}
      </div>
    </>
  );
};
export default FarmacieInsertionRetail;
